<template>
  <span
    :id="isOpen ? 'open-arende-status' : 'closed-arende-status'"
    :class="{
      'bg-avtalat-darkteal': isOpen,
      'bg-avtalat-paleblue': !isOpen,
      'h-md': true,
      'items-center': true,
      'px-xs': true,
      'right-xs': true,
      'rounded-2xl': true,
      'text-text-secondary': !isOpen,
      'type-body-md': true,
      'text-white': isOpen,
      'top-xs': true,
      absolute: true,
      flex: true,
    }"
    >{{ isOpen ? "Öppen" : "Stängd" }}</span
  >
</template>
<script setup lang="ts">
type ArendeStatusPillProps = {
  isOpen: boolean;
};
defineProps<ArendeStatusPillProps>();
</script>
